export default {
      id: "chassis-usage",
      viewBox: "0 0 39 8",
      url: __webpack_public_path__ + "img/icons.svg#chassis",
      toString: function () {
        return this.url;
      }
    }